


























import { Vue, Prop, Component, Watch } from 'vue-property-decorator'

@Component
export default class CancelValidationDialog extends Vue {
  @Prop({ default: false }) enable!: boolean
  @Prop() private text!: string
  private dialog: boolean = this.enable

  @Watch('enable')
  enableWatcher (val: boolean) {
    this.dialog = val
  }

  getText() {
    if (this.text == null || this.text.length < 1) {
      return this.$t('general.loading').toString()
    }
    return this.text
  }

  private cancel() {
    this.$emit('cancel')
  }
}
